"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDataLayer = void 0;
const react_1 = require("react");
function useDataLayer(dataLayerName) {
    return (0, react_1.useMemo)(() => {
        if (typeof window === 'undefined') {
            return null;
        }
        const name = dataLayerName;
        if (!window[name]) {
            window[name] = [];
        }
        return window[name];
    }, [dataLayerName]);
}
exports.useDataLayer = useDataLayer;
//# sourceMappingURL=use-datalayer.js.map